import { useQuery } from '@apollo/react-hooks';
import { gql } from '@apollo/client';
import type {
  GetDistinctiveScholarship,
  DistinctiveScholarship,
} from './types';

const GET_DISTINCTIVE_SCHOLARSHIP = gql`
  query ($id: ID!) {
    application(id: $id) {
      distinctiveScholarships {
        files {
          name
          id
          link
        }
        fundingSource
        reason
      }
      applicationNo
    }
  }
`;

const initialDistinctiveScholarships: DistinctiveScholarship[] = [
  {
    fundingSource: '',
    reason: '',
    files: [],
  },
  {
    fundingSource: '',
    reason: '',
    files: [],
  },
];

export const useGetDistinctiveScholarship = (
  id: string,
): GetDistinctiveScholarship => {
  const { data, loading, error } = useQuery(GET_DISTINCTIVE_SCHOLARSHIP, {
    variables: { id },
    skip: !id,
    fetchPolicy: 'network-only',
  });

  const fetchedDistinctiveScholarships: DistinctiveScholarship[] =
    data?.application?.distinctiveScholarships ?? [];
  const applicationNo: string = data?.application?.applicationNo ?? '';

  const distinctiveScholarships: DistinctiveScholarship[] =
    initialDistinctiveScholarships.map(
      (scholarship, index) =>
        fetchedDistinctiveScholarships[index] ?? scholarship,
    );

  return { distinctiveScholarships, applicationNo, loading, error };
};
